import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaUserFriends } from 'react-icons/fa'
import { motion } from 'framer-motion';

const Container = styled(motion.div)`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const Scroll = styled.div`
    overflow: scroll;
    height: 100%;
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;

    padding-bottom: 40px;
`

const Wrapper = styled.div`
    width: 85%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    margin: 20px 0 10px 0;

    background-color: #fff;

    // border: 1px solid rgba(0, 0, 0, 0.1);
    /* border-radius: 15px; */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
    text-decoration: none;
`

const Image = styled.div`
    width: 100%;
    padding-bottom: 60%;
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 15px 15px 0 0;
`

const DescriptionWrapper = styled.div`
    height: 75px;
    width: 90%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const Description = styled.div`
    height: 75%;
    width: 100%;
    display: flex;    
    flex-direction: column;
    justify-content: space-evenly;

    color: rgba(23, 25, 37, 1);
`

const Title = styled.span`
    font-weight: bold;
    font-size: 1.2em;
`

const Date = styled.span`
    font-size: 1em;
    color: white;
    font-weight: 400;
`

const TextContainer = styled.div`
    margin-top: 10px;
    width: 85%;

    color: black;

    white-space: pre-wrap;

    display: flex;
    flex-direction: column;
    align-items: center;
`

const Text = styled.span`
    font-weight: 600;
    font-size: 0.8rem;
`

const MapContainer = styled.div`
    height: 200px;
    width: 100%;
    padding: 15px 0 5px 0;
`

const Button = styled(Link)`

    position: fixed;
    bottom: 0;

    margin: 10px 0;
    min-height: 50px;
    width: 80%;
    align-self: center;
    
    text-align: center;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    font-weight: bold;
    color: white;
    // background-color: #9D3C72;
    background-color: #FF3130;
    background-size: cover;
    background-position: center;
    text-decoration: none;

    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.6);
    /* box-shadow: 3px 3px 0 0 white, 6px 6px 0 0 #004AAD, 9px 9px 0 0 white; //, 12px 12px 0 0 black; */
`

const ToggleFriendList = styled(FaUserFriends)`
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 2em;
    color: white;
`

const SpotifyWrapper = styled.div`
    width: 100%;
    padding: 30px 0;
`

const FirstWrapper = styled.div`
    position: relative;
    width: 100%;
    
    display: flex;
    justify-content: center;
    align-items: center;
    
    padding: 20px 0;
`

const Logo = styled.img`
    width: 60%;
    max-width: 500px;
    min-width: 300px;
`


const Area = styled.div`
    z-index: 2;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    width: 100%;
`

const Overlay = styled.div`
    height: 100%;
    width: 100%;

    position: absolute;
    top: 0;
    left: 0;

    background-color: rgba(0, 0, 0, 0.55);
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: center;
`

export {
    Container,
    Scroll,
    SpotifyWrapper,
    Wrapper,
    Image,
    DescriptionWrapper,
    Description,
    Title,
    Date,
    FirstWrapper,
    TextContainer,
    Text,
    MapContainer,
    Button,
    ToggleFriendList,
    Logo,
    Area,
    Overlay
}